function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.82 24.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m11.34,1.96l-1.92,6.28,6.42.05c.82-.1.09,1.01-.12,1.37l-8.45,13.47c-.59.68-1.3,0-1.12-.41l1.46-8.95H1.12c-.75.01-.55-.85-.19-1.2L10.43.82c.52-.54,1.18-.05.9,1.13Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: "1.21px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/Charging.e5036fd1c5cd7561f0a0d456eace212a.svg";
export { ForwardRef as ReactComponent };